//banner
var banner = function(){
  $('.index_banner').slick({
    autoplay: true,
    arrows: false,
    dots:false,
    infinite: true,
    speed: 500,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    fade: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          dots: true
        }
      }
    ]
  });
  $('.index_banner').init(function(slick){
    $('.index_banner .item.slick-current').addClass('active').siblings().removeClass('active')
  })
  $('.index_banner').on('afterChange',function(slick,currentSlide){
    $('.index_banner .item.slick-current').addClass('active').siblings().removeClass('active');
    var _index = $('.index_banner').slick('slickCurrentSlide')
    $('.bannerdiv .number span').eq(_index).addClass('active').siblings().removeClass('active')
  })
  $('.bannerdiv .number span').click(function(){
    var _index = $(this).index();
    $('.index_banner').slick('slickGoTo',_index);
    $(this).addClass("active").siblings().removeClass("active")
  });
  $('.bannerdiv .prev').click(function(){
    $('.index_banner').slick('slickPrev')
  })
  $('.bannerdiv .next').click(function(){
    $('.index_banner').slick('slickNext');
  });
}
export default {
  banner
}



//////////////////
// WEBPACK FOOTER
// ./static/slick/index.js
// module id = GQe1
// module chunks = 1